var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaybillNotactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 54,
    viewBox: "0 0 80 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.88 0H8.12C3.64 0 0 3.64 0 8.12V45.57C0 50.05 3.64 53.69 8.12 53.69H71.87C76.35 53.69 79.99 50.05 79.99 45.57V8.12C79.99 3.64 76.35 0 71.87 0H71.88ZM75.68 45.58C75.68 47.67 73.98 49.38 71.88 49.38H8.12C6.03 49.38 4.32 47.68 4.32 45.58V17.49H75.67V45.58H75.68ZM75.68 13.17H4.32V8.13C4.32 6.04 6.02 4.33 8.12 4.33H71.87C73.96 4.33 75.67 6.03 75.67 8.13V13.17H75.68Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4695 28.5898H13.0395C11.5097 28.5898 10.2695 29.83 10.2695 31.3598V34.9798C10.2695 36.5097 11.5097 37.7498 13.0395 37.7498H20.4695C21.9994 37.7498 23.2395 36.5097 23.2395 34.9798V31.3598C23.2395 29.83 21.9994 28.5898 20.4695 28.5898Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaybillNotactive);
export default __webpack_public_path__ + "static/media/paybill-notactive.2d7f076c2a9c28f12de1fd6839452ae4.svg";
export { ForwardRef as ReactComponent };